import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '@hooks/index';
import { ConditionalRendering } from '../common/conditional-rendering';
import { environmentSelector } from '@selectors/commonSelectors';
import { setLanguage } from '@actions/common/actionCreators';
import { useLocation } from '@hooks/useLocation';
import { exportToExcel, filterObject } from '@hooks/useTranslations';

const StyledContainer = styled.div`
    padding: 10px;
    border-bottom : 2px solid gray;
    position: relative;
    z-index:1001
`;

const StyledButton = styled.button<{ isSelected: boolean }>`
    padding: 3px;
    background-color: ${({ isSelected }) => (isSelected ? '#90EE90' : '')};;
    outline: none;
    border-radius: 3px;
    cursor: pointer;
    margin-right: 20px;
    color: black;
`;

const languages = {
    DUBUG: 'debug',
    ENGLISH: 'en',
};

const eventCodes = {
    KEY1 : 'Digit1'
};

export const DebugLabelSelector = () => {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const [keys, setKeys] = useState(new Set());
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const { language, devEnvironment } = useAppSelector(environmentSelector);
    const messages = useAppSelector(state => state.common.messages);
    const { currentLocation } = useLocation();

    useEffect(() => {
        setKeys(new Set());
    }, [currentLocation]);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.code === eventCodes.KEY1 && devEnvironment) {
                event.preventDefault();
                setDropdownVisible(prev => !prev);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    useEffect(() => {
        const originalFormatMessage = intl.formatMessage;
        intl.formatMessage = (descriptor, ...args) => {
            if (descriptor?.id) {
                setKeys((prev) => new Set(prev).add(descriptor.id));
            }
            return originalFormatMessage(descriptor, ...args);
        };
        return () => {
            intl.formatMessage = originalFormatMessage; // Restore original function
        };

    }, [intl]);

    function getTranslations() {
        const filteredObject = filterObject(messages['en'], keys);
        exportToExcel(filteredObject, currentLocation);
    }


    return (
        <ConditionalRendering isTrue={isDropdownVisible && devEnvironment} >
            <StyledContainer>
                <StyledButton isSelected={language === languages.DUBUG} onClick={() => dispatch(setLanguage('debug'))}>
                    Show Content Labels
                </StyledButton>
                <StyledButton isSelected={language === languages.ENGLISH} onClick={() => dispatch(setLanguage('en'))}>
                    Show Content
                </StyledButton >
                <StyledButton onClick={() => getTranslations()}>
                    Download Content
                </StyledButton>
            </StyledContainer>
        </ConditionalRendering>
    );
};